export type OfferingType = "okopunkte" | "ausgleichsflaechen";

export type GeoJSONGeometry =
  | { type: "Point"; coordinates: [number, number] }
  | { type: "Polygon"; coordinates: [number, number][][] }
  | { type: "MultiPolygon"; coordinates: [number, number][][][] };

/**
 * The localStorage key each funnel persists its session under (`useFormPersistence`). Everything
 * that prefills a funnel or reads its session back (the /lp heroes, the price estimator, Klara's
 * form context and her `suggest_action` prefill) needs the same key, so it is defined once, here.
 */
export const QUICK_REQUEST_PERSISTENCE_KEY = "quick_request_v2";

/** See QUICK_REQUEST_PERSISTENCE_KEY — the seller funnel's session. */
export const QUICK_OFFERING_PERSISTENCE_KEY = "quick_offering_v2";
